"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTransformOptions = exports.USERGEEK_BUILT_IN_EVENT_ANY_EVENT_OPTION = exports.USERGEEK_BUILT_IN_EVENT_ACTIVE_USER_OPTION = exports.USERGEEK_BUILT_IN_EVENT_NEW_USER_OPTION = exports.USERGEEK_CUSTOM_EVENTS_GROUP_OPTION = exports.USERGEEK_BUILT_IN_EVENTS_GROUP_OPTION = exports.QueryEventVariantNameComponent = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const antd_1 = require("antd");
const use_custom_compare_1 = require("use-custom-compare");
const lodash_1 = __importDefault(require("lodash"));
const Utils_1 = require("src/hello_assets/src/components/system/util/Utils");
const ICEventQueryUtil_1 = require("src/hello_assets/src/util/ICEventQueryUtil");
const QueryEventVariantNameComponent = (props) => {
    const value = props.value;
    const onChange = (0, react_1.useCallback)((_, option) => {
        // console.log("QueryEventVariantNameComponent.onChange: option", option);
        const variantValue = valueTypeFromOptionType(option);
        props.onChange(props.uniqueId, variantValue);
    }, [props.uniqueId, props.onChange]);
    const onFocus = (0, use_custom_compare_1.useCustomCompareCallback)(() => {
        if (!props.loading) {
            props.onFetch();
        }
    }, [props.onFetch, props.loading], lodash_1.default.isEqual);
    const optionsWithEventNames = (0, use_custom_compare_1.useCustomCompareMemo)(() => {
        return lodash_1.default.map(props.eventNames, v => optionTypeFromEventName(v));
    }, [props.eventNames], lodash_1.default.isEqual);
    const transformedOptions = (0, use_custom_compare_1.useCustomCompareMemo)(() => {
        if (props.transformOptions) {
            return props.transformOptions(props.uniqueId, props.index, value, optionsWithEventNames);
        }
        return optionsWithEventNames;
    }, [props.uniqueId, props.index, value, props.transformOptions, optionsWithEventNames], lodash_1.default.isEqual);
    return React.createElement(React.Fragment, null,
        React.createElement(antd_1.Form.Item, null,
            React.createElement(antd_1.Select, { bordered: true, allowClear: true, loading: props.loading, value: value, optionLabelProp: "label", placeholder: props.placeholder || "Event Name", notFoundContent: "Not found", defaultActiveFirstOption: true, showSearch: true, labelInValue: true, onChange: onChange, onFocus: onFocus, options: transformedOptions, dropdownMatchSelectWidth: false })));
};
exports.QueryEventVariantNameComponent = QueryEventVariantNameComponent;
const optionTypeFromEventName = (name) => {
    const eventName = name || "";
    return {
        label: (0, Utils_1.truncateMiddle)(eventName, 60),
        value: eventName,
        type: "event"
    };
};
const valueTypeFromOptionType = (option) => {
    if (option) {
        switch (option.type) {
            case "event": {
                return { type: "event", name: `${option.value}`, value: `${option.value}`, label: `${option.value}` };
            }
            case "newUser": {
                return { type: "newUser", value: "newUser", label: ICEventQueryUtil_1.QueryEventVariantSpecialEventNames.newUser };
            }
            case "session": {
                return { type: "session", value: "session", label: ICEventQueryUtil_1.QueryEventVariantSpecialEventNames.session };
            }
            case "anyEvent": {
                return { type: "anyEvent", value: "anyEvent", label: ICEventQueryUtil_1.QueryEventVariantSpecialEventNames.anyEvent };
            }
        }
    }
};
exports.USERGEEK_BUILT_IN_EVENTS_GROUP_OPTION = {
    type: "event",
    label: "Default Events",
    disabled: true,
};
exports.USERGEEK_CUSTOM_EVENTS_GROUP_OPTION = {
    type: "event",
    label: "Events",
    disabled: true,
};
exports.USERGEEK_BUILT_IN_EVENT_NEW_USER_OPTION = {
    type: "newUser",
    label: ICEventQueryUtil_1.QueryEventVariantSpecialEventNames.newUser,
    value: ICEventQueryUtil_1.QueryEventVariantSpecialEventNames.newUser
};
exports.USERGEEK_BUILT_IN_EVENT_ACTIVE_USER_OPTION = {
    type: "session",
    label: ICEventQueryUtil_1.QueryEventVariantSpecialEventNames.session,
    value: ICEventQueryUtil_1.QueryEventVariantSpecialEventNames.session,
};
exports.USERGEEK_BUILT_IN_EVENT_ANY_EVENT_OPTION = {
    type: "anyEvent",
    label: ICEventQueryUtil_1.QueryEventVariantSpecialEventNames.anyEvent,
    value: ICEventQueryUtil_1.QueryEventVariantSpecialEventNames.anyEvent,
};
const createTransformOptions = (parameters) => {
    return (uniqueId, index, value, optionsWithEventNames) => {
        const events = parameters.filterOutEventsForUniqueness ? lodash_1.default.filter(optionsWithEventNames, (v) => {
            if ((value === null || value === void 0 ? void 0 : value.type) === "event") {
                if (lodash_1.default.isEqual(value.name, v.value)) {
                    return true;
                }
            }
            return !lodash_1.default.includes(parameters.filledEventNames, v.value);
        })
            :
                optionsWithEventNames;
        const buildInOptions = [];
        // noinspection EqualityComparisonWithCoercionJS
        if (parameters.specialEvents != undefined && parameters.specialEvents.length > 0) {
            const isValidIndex = parameters.specialEventsInAllRows === true || index === 0;
            if (isValidIndex) {
                buildInOptions.push(exports.USERGEEK_BUILT_IN_EVENTS_GROUP_OPTION);
                lodash_1.default.each(parameters.specialEvents, v => {
                    switch (v) {
                        case "newUser": {
                            const hasBuiltInNewUserEvent = lodash_1.default.some(events, (v) => v.type === exports.USERGEEK_BUILT_IN_EVENT_NEW_USER_OPTION.type);
                            if (!hasBuiltInNewUserEvent) {
                                buildInOptions.push(exports.USERGEEK_BUILT_IN_EVENT_NEW_USER_OPTION);
                            }
                            break;
                        }
                        case "session": {
                            const hasBuiltInActiveUserEvent = lodash_1.default.some(events, (v) => v.type === exports.USERGEEK_BUILT_IN_EVENT_ACTIVE_USER_OPTION.type);
                            if (!hasBuiltInActiveUserEvent) {
                                buildInOptions.push(exports.USERGEEK_BUILT_IN_EVENT_ACTIVE_USER_OPTION);
                            }
                            break;
                        }
                        case "anyEvent": {
                            const hasBuiltInAnyEventEvent = lodash_1.default.some(events, (v) => v.type === exports.USERGEEK_BUILT_IN_EVENT_ANY_EVENT_OPTION.type);
                            if (!hasBuiltInAnyEventEvent) {
                                buildInOptions.push(exports.USERGEEK_BUILT_IN_EVENT_ANY_EVENT_OPTION);
                            }
                            break;
                        }
                    }
                });
            }
        }
        const eventsTitleOption = events.length > 0 ? exports.USERGEEK_CUSTOM_EVENTS_GROUP_OPTION : undefined;
        const result = lodash_1.default.compact([
            ...buildInOptions,
            eventsTitleOption,
            ...events,
        ]);
        return result;
    };
};
exports.createTransformOptions = createTransformOptions;
